<template>
  <div>
    <v-card color="appBar" elevation="0" class="header-card">
      <a-toolbar
        class="primary-gradient pl-4"
      >
        <v-icon left dark> mdi-label-variant </v-icon> <span class="widget-title">{{ widgetData.title }}</span>
        <!-- <span id="close" class="e-template-icon e-clear-icon" @click="onCloseIconHandler" v-if="widgetData.canShowHide === 'true'"></span> -->
        <v-spacer></v-spacer>
      </a-toolbar>
      <v-list
        color="appBarT"
        flat
        tile
        style="padding: 0px"
        v-if="
          widgetData.contentTitle ||
          widgetData.contentSubtitle ||
          file_count > 1
        "
      >
        <v-list-item class="d-flex justify-end">
          <v-list-item-content
            v-if="widgetData.contentTitle || widgetData.contentSubtitle"
          >
            <v-list-item-title v-if="widgetData.contentTitle"
              ><h3>{{ widgetData.contentTitle }}</h3></v-list-item-title
            >
            <v-list-item-subtitle v-if="widgetData.contentSubtitle">{{
              widgetData.contentSubtitle
            }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="justify-end" v-if="file_count > 1">
            <v-switch
              right
              v-model="cycle"
              color="pageHeader"
              :label="$t('dashboard.slideShow')"
              inset
            ></v-switch>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>

    <ImageSliderWidget
      v-if="widgetData.widgetType.toLowerCase() == 'imageslider'"
      :widget="widgetData"
      :cycle="cycle"
    ></ImageSliderWidget>
    <PdfviewerWidget
      v-else-if="widgetData.widgetType.toLowerCase() == 'pdfviewer'"
      :widget="widgetData"
    ></PdfviewerWidget>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ImageSliderWidget from "/src/components/widget/ImageSliderWidget.vue";
import PdfviewerWidget from "/src/components/widget/PdfviewerWidget.vue";
import AToolbar from "../../wrapper-component/AToolbar.vue";

export default {
  name: "Widget",
  props: ["widgetData"],
  components: {
    ImageSliderWidget,
    PdfviewerWidget,
    AToolbar
  },
  data() {
    return {
      cycle: false,
    };
  },
  computed: {
    file_count() {
      return this.widgetData.files ? this.widgetData.files.length : 0;
    },
  },
  methods: {
    ...mapActions({
      widgetToggleApi: "widget/widgetToggle",
    }),
    onCloseIconHandler() {
      this.widgetToggleApi({ id: this.widgetData.id, isShow: false });
    },
  },
};
</script>

<style></style>
